'use client';

import DownIcon from '@/icons/down.svg';
import PersonIcon from '@/icons/person.svg';
import PeopleIcon from '@/icons/two-people.svg';
import { RelatedContact } from '@/types';
import Link from 'next/link';

type Props = {
  id: string;
  contacts: RelatedContact[];
};

const handleAnchorClick = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }
};

function ContactAnchor(props: Props) {
  const { id, contacts } = props;
  return (
    <Link className='contact-anchor' href='#contact' onClick={() => handleAnchorClick(id)}>
      <div className='contact-anchor__container'>
        <div className='contact-anchor__icon'>
          {contacts.length === 1 && <PersonIcon />}
          {contacts.length === 2 && <PeopleIcon />}
        </div>
        <div className='contact-anchor__prelude'>
          {contacts.length === 1 && 'Ansprechpartner*in'}
          {contacts.length === 2 && 'Wir beraten Sie gern:'}
        </div>
        <div className='contact-anchor__name'>
          {contacts.length === 1 && contacts[0].contact.name}
          {contacts.length === 2 && 'Ihr Beratungsteam'}
          <DownIcon />
        </div>
      </div>
    </Link>
  );
}

export default ContactAnchor;
